// Shared configuration constants for Guacamole client and connection
const CONFIG = {
  API_BASE_URL: "",
  WS_TUNNEL_URL: "",
  RESIZE_DEBOUNCE_MS: 250,
  CONNECTION_TIMEOUT_MS: 30000,
  MODAL_AUTO_HIDE_MS: 1000,
  ERROR_REDIRECT_DELAY_MS: 3000
};

export default CONFIG;
